// 정산 API 응답 매핑 (드로어용 내역 API는 필드명 미확정 → 방어적 매핑)
export const pickArray = d => {
  if (Array.isArray(d)) return d;
  if (!d || typeof d !== 'object') return [];
  const k = ['items', 'list', 'content', 'results', 'rows', 'payments', 'transactions', 'usages', 'data'].find(
    key => Array.isArray(d[key])
  );
  return k ? d[k] : [];
};
export const pickNum = (obj, keys) => {
  for (const k of keys) {
    const v = Number(obj?.[k]);
    if (obj?.[k] != null && !Number.isNaN(v)) return v;
  }
  return null;
};

export const AMOUNT_KEYS = [
  'amount', 'pg_amount', 'payment_amount', 'paid_amount', 'total_amount', 'point_amount', 'point',
  'discount_amount', 'coupon_amount', 'settlement_amount', 'net_amount', 'price',
];

// 정산 대상만: 취소건 제외, 포인트는 사용(USE)만 (내역 API는 EARN·CANCEL도 함께 반환)
export const isSettleable = (ch, it) => {
  if (/CANCEL/i.test(it.status ?? '')) return false;
  if (ch === 'paypay_point' && it.transaction_type) return /^USE$/i.test(it.transaction_type);
  return true;
};

// GET /settlement/daily days[] → { 'YYYY-MM-DD': day }. 거래 0건인 날은 빼서 화면에 '—' 로 둔다
export const toDayMap = days =>
  Object.fromEntries(
    (days ?? []).filter(d => Object.values(d.counts ?? {}).some(n => n > 0) || d.total).map(d => [d.date, d])
  );
